import { UseCase } from './UseCase';
export class PlayerJoinBarUseCase extends UseCase {
    constructor(applicationServices) {
        super();
        this.applicationServices = applicationServices;
    }
    execute(event) {
        return this.applicationServices.bar.hasAvailableTableStool()
            .then(hasAvailableTableStool => hasAvailableTableStool ? this.onTableStoolAvailable(event.username) : this.onTableStoolUnavailable(event.username))
            .catch(error => Promise.reject(error));
    }
    onTableStoolAvailable(username) {
        return this.applicationServices.bar.installPlayerOnTableStool(username);
    }
    onTableStoolUnavailable(username) {
        return this.applicationServices.bar.hasAvailableBarStool()
            .then(hasAvailableBarStool => hasAvailableBarStool ? this.onBarStoolAvailable(username) : this.onBarStoolUnavailable(username))
            .catch(error => Promise.reject(error));
    }
    onBarStoolUnavailable(username) {
        return this.applicationServices.bar.playerQuit(username);
    }
    onBarStoolAvailable(username) {
        return this.applicationServices.bar.installPlayerOnBarStool(username);
    }
}
